import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSurvey } from ".";

export function useUpdateSurvey(){
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['survey'],
        mutationFn: updateSurvey,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['project'], exact: false});
            queryClient.invalidateQueries({queryKey: ['survey'], exact: false});
        }
    })
}
